import { Component, Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';

import { IUserInfo } from './user-info.model';
import { IAccess } from './access.model';
import { HttpService } from './http.service';

@Injectable()
export class AuthService {
    API_URL: string;
    ENV: string;
    accessDetails: IAccess = new IAccess();
    
    constructor(private _http: Http, private _httpService: HttpService) {
        this.API_URL = process.env.API_URL;
        this.ENV = process.env.ENV;
    }

    isLoggedIn = false;
    userInfo: IUserInfo = new IUserInfo();
    loginUserSubject$: BehaviorSubject<IUserInfo>;
    redirectUrl: string;
    userRoles: string[];
    

    initializeDataService(): void {
        this.loginUserSubject$ = new BehaviorSubject(new IUserInfo());
        if (this.userInfo.userId)
            this.loginUserSubject$.next(this.userInfo);
        else

            //TODO: Redirect to Error page to ask user to refresh the page.
            console.log('TODO: Redirect to Error page to ask user to refresh the page ');

    }
    subscribeToLoginService(): Observable<IUserInfo> {
        if (!this.loginUserSubject$)
            this.initializeDataService();
        return this.loginUserSubject$.asObservable();
    }

    login(): Observable<boolean> {
        try {
            if (window.location.href.includes('token')) {

                var params = new URLSearchParams(window.location.hash);
                // ONLY SOLO/MYID STG: In case BLOCK EXTERNAL USERS option in SOLO needs to be turned off
                // let myId_idToken = window.location.hash.split('#access_token=').pop();
                ///////////////////////////////////////////////////////////////////////////

                // let myId_idToken = params.get('id_token');
                let idToken = params.get('id_token');
                let email = params.get('email');
                let roles = params.get('roles');
                this.userRoles = [roles];
                this._httpService.setToken(idToken);
                return this.getUserInfo(email);
                // return this.setToken(myId_idToken);
            }
            return Observable.of(false);

        }

        catch (ex) {
            console.log('No User Info found, exception: >>> ' + ex);
            return Observable.of(true).do(val => this.isLoggedIn = false);
        }
    }


    setToken(id_token: string): Observable<boolean> {
        if (id_token != null) {            
            return this._httpService.httpPost(this.API_URL + 'login/GenerateToken', null, null, id_token)
                .map(res => res.json())
                .do(res => {
                    if (res != null) {
                        console.log(res.access_token);
                        this.userRoles = res.roles;
                        this._httpService.tokenAPI = res.access_token;
                    }
                }, error => {

                    console.error(error);
                    return Observable.throw("Unauthorized user");
                })
                .flatMap(res => {
                    return this.getUserInfo(res.email);
                });
        }
        else {
            localStorage.removeItem('userName');
            return Observable.of(true);
        }

    }


    getUserInfo(email: string): Observable<boolean> {

        let result = this._httpService.httpGet(this.API_URL + 'user/GetUser?email=' + email)
            .map(res => res.json())
            .do(res => {
                if (res != null) {
                    let userData = this.toUserInfo(res);
                    let details = this.toAccessDetails(userData);

                    this.userInfo = userData;
                    this.accessDetails = details;

                    this.isLoggedIn = true;
                    return Observable.of(true);
                }
            }, error => console.error(error));

        return result;
    }

    toUserInfo(r: any) {

        let userInfo = <IUserInfo>{
            accessToken: this._httpService.tokenAPI,
            email: r.Email,
            name: r.Name,
            phone: r.Phone,
            photoUrl: r.PhotoUrl,
            userId: r.UserId,
            userName: r.userName,
            lastLoginDate: r.LastLoginDate,
            role: this.userRoles
        };
        return userInfo;
    }

    toAccessDetails(r: any) {
        var details = <IAccess>({
            access_token: r.accessToken,
            userId: r.userId
        });
        return details;
    }

    isUserInRole(role: string): boolean {
        if (this.userInfo != null && this.userInfo.userId && this.userInfo.role) {
            return this.userInfo.role.find(x => x.toLowerCase() == role.toLowerCase()) != null;
        }
        return true;
    }

    error: Response = null;
    private handleError(error: Response) {        
        this.error = error;
        return Observable.throw(error || 'Server error');
    }



}





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/auth.service.ts